import React, { useState } from 'react';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import { Table, IconButton, Button, Grid, Box, Tooltip, TablePagination, Typography } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Edit, Delete } from '@material-ui/icons';
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';
import * as RFIcon from 'react-feather';
import language from '../../languages';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [32,32],
    iconAnchor: [16, 32],
});
L.Marker.prototype.options.icon = DefaultIcon;

const useStyles = makeStyles({
    deleteTitle:{
        padding: '8px 16px',
        color: '#ffffff',
        backgroundColor: '#2735A4',
    },
    deleteButton: {
      color: '#2735A4',
      margin: '8px 8px;',
      textTransform: 'capitalize',
      borderColor: '#2735A4'
    },
    deleteConfirmButton: {
        color: '#ffffff',
        backgroundColor: '#3076CA',
        '&:hover': {
          backgroundColor: fade('#3076CA', 0.75),
        },
        margin: '8px 8px;',
        textTransform: 'capitalize'
    },
});


export default function BaseMap(props) {
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteRow, setDeleteRow] = useState(null);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    
    const { readOnly, pager, setPageNumber, setItemsPerPage, sidePanelDetailId, lang, meta, handleCustomAction } = props;
    const classes = useStyles();

    const handleChangePage = (event, newPage) => {
        const { setPageNumber } = props;
        setPageNumber(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        debugger;
        setRowsPerPage(parseInt(event.target.value, 10));
        //setPage(0);
    };

    const getLatLngBounds = () => {
      let bounds = []
      props.rows.forEach((row, i) => {
        bounds.push([row[meta.map.latitude.field], row[meta.map.longitude.field]])
      })
      return bounds
    }
    
    return (
        <>
            {
                <ConfirmationDialog
                    dialogProps={{
                        open: deleteDialogOpen,
                        onClose: () => { },
                    }}
                    content={
                        <>
                        <div className={classes.deleteTitle}><Typography variant="h6" >{language[lang].Delete}</Typography></div>
                        <Box p={4} width='600px'>
                            <Box p={2} >
                            <Typography variant="subtitle2" >{language[lang].Confirm_Message} {props.meta.entityName}?</Typography>
                            </Box>
                        </Box>
                        </>
                    }
                    dismissiveAction={<Button variant="outlined" className={classes.deleteButton} onClick={() => { setDeleteRow(null); setDeleteDialogOpen(false) }}>{language[lang].Cancel}</Button>}
                    confirmingAction={<Button variant="contained" className={classes.deleteConfirmButton}  onClick={() => { props.onDelete(deleteRow); setDeleteDialogOpen(false) }}>{language[lang].Delete}</Button>}
                />
            }
            <Box p={2}>
              {(props.rows && props.rows.length > 0 && props.meta.table) ? 
                <MapContainer bounds={getLatLngBounds()} style={{width: 'auto', height: 600}} 
                   zoom={15}>
                  <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  {props.rows.map((row, i) => {
                    const position = {
                      lat: row[meta.map.latitude.field],
                      lng: row[meta.map.longitude.field],
                    }
                    return <Marker position={position}>
                        <Popup>
                          {meta.map.popupText.getPopupHTML(row)}
                        </Popup>
                      </Marker>
                  })}
                </MapContainer>
               :
                'No Data Found'
              }
            </Box>
            <TablePagination
                // rowsPerPageOptions={[4, 12, 24]}
                rowsPerPageOptions={[12]}
                component="div"
                count={pager.totalCount}
                rowsPerPage={pager.itemsPerPage}
                page={pager.pageNo}
                onChangePage={(e, newPage) => setPageNumber(newPage)}
                onChangeRowsPerPage={(e) => setItemsPerPage(e.target.value)}
            />
        </>
    )
}